<template>
    <div class="p-4">
        <div class="mb-2">
      <a-button @click="$router.back()" class="w-auto">
        Regresar
      </a-button>
    </div>
    <h2 class="text-2xl font-bold mb-4">Detalles de Configuración de Pago</h2>
    <template v-if="loading">
      <div class="flex items-center justify-center h-full">
        <a-loader class="h-10 w-10 mt-4"/>
      </div>
    </template>
    <template v-else>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Primera columna: Datos generales -->
        <div class="bg-white shadow rounded p-4">
          <h3 class="text-xl mb-2">Datos Generales</h3>
          <!-- <p><strong>ID:</strong> {{ details.id }}</p> -->
          <p>
            <strong>Razón de pago:</strong>
            {{ paymentTypeLabel }}
            <span v-if="details.type === 'semester'"> {{ details.target_semester }}</span>
            <span v-else-if="details.type === 'courses'"> {{ details.courses_count }}</span>
          </p>
          <!-- <p><strong>Precio al contado:</strong> ${{ details.full_price }}</p> -->
          <!-- <p><strong>Precio a crédito:</strong> ${{ details.credit_price }}</p> -->
          <p><strong>Inscripción y primera mensualidad:</strong> ${{ details.initial_price }}</p>
          <p><strong>Cuotas restantes:</strong> ${{ details.installments_price }}</p>
          <p><strong>Valor pago tardío:</strong> ${{ details.late_installment_extra }}</p>
          <p>
            <strong>Días de gracia para pago tardío:</strong>
            {{ details.late_installment_grace_period_days }} días
          </p>
          <p><strong>Cantidad de cuotas:</strong> {{ details.installments }}</p>
        </div>
    
        <!-- Segunda columna: Detalles adicionales -->
        <div class="bg-white shadow rounded p-4">
          <h3 class="text-xl mb-2">Detalles Adicionales</h3>
          <p>
            <strong>Fechas de cuotas:</strong>
            <ul class="list-disc ml-4" v-if="details.installment_dates.length">
              <li v-for="(date, index) in details.installment_dates" :key="index">
                <strong>Cuota {{ index + 1 }}: </strong> {{ date }}
              </li>
            </ul>
            <span v-else class="text-gray-500">Sin fechas registradas</span>
          </p>
          <p>
            <strong>Métodos de pago al contado:</strong>
            {{ fullPaymentLabels.join(', ') }}
          </p>
          <p>
            <strong>Métodos de pago a crédito:</strong>
            {{ installmentPaymentLabels.join(', ') }}
          </p>
          <p><strong>Período:</strong> {{ details.period_id }}</p>
          <!-- <p><strong>Cuotas Restantes Reales:</strong> {{ details.real_remaining_installments }}</p> -->
        </div>
      </div>
    </template>
    </div>
  </template>
    
  <script>
  export default {
    data: () => ({
      details: {
        id: null,
        type: "semester",
        target_semester: null,
        courses_count: null,
        // full_price: 0,
        // credit_price: 0,
        initial_price: 0,
        installments_price: 0,
        late_installment_extra: 0,
        late_installment_grace_period_days: null,
        installments: 0,
        installment_dates: [],
        full_payment_methods: [],
        installment_payment_methods: [],
        created_at: '',
        updated_at: '',
        period_id: null,
        full_late_credit_price: 0,
        real_remaining_installments: 0
      },
      paymentOptions: [
        { value: 1, label: "Efectivo" },
        { value: 3, label: "Transferencia Bancaria" },
        { value: 5, label: "Zelle" },
      ],
      paymentReason: [
        { value: "semester", label: "Semestre" },
        { value: "courses", label: "Materia" },
      ],
      loading: false
    }),
    computed: {
      paymentTypeLabel() {
        const option = this.paymentReason.find(
          (opt) => opt.value === this.details.type
        );
        return option ? option.label : this.details.type;
      },
      fullPaymentLabels() {
        const paymentOptionsLabel = [];
        this.details.full_payment_methods.forEach(code => {
          const option = this.paymentOptions.find(opt => opt.value === code);
          if(option) paymentOptionsLabel.push(option.label);
        });
        return paymentOptionsLabel;
      },
      installmentPaymentLabels() {
        const paymentOptionsLabel = [];
        this.details.installment_payment_methods.forEach(code => {
          const option = this.paymentOptions.find(opt => opt.value === code);
          if(option) paymentOptionsLabel.push(option.label);
        });
        return paymentOptionsLabel;
      }
    },
    mounted() {
      this.loading = true;
      this.$repository.periods.getPaymentSetting(this.$route.params.id)
        .then(({ data }) => {
          Object.entries(data).forEach(([key, value]) => {
            this.details[key] = value;
          });
          this.loading = false;
        })
        .catch(() => {
          this.$message.error("Ocurrió un error al cargar la información");
        });
    }
  };
  </script>
    
  <style scoped>
  /* Puedes agregar estilos personalizados para mejorar la presentación */
  </style>
  